import { TableCell, TableRow, Typography } from '@mui/material';

import { convertVideoToImage } from 'utils';
import { Image } from 'components';

export default function BenchmarkDrillSubmissionsItem({
	submission,
	handleClick
}) {
	return (
		<TableRow>
			<TableCell>
				<Image
					src={convertVideoToImage(submission.preview)}
					variant="rounded"
					size={80}
					onClick={() => handleClick(submission)}
					style={{ cursor: 'pointer' }}
				/>
			</TableCell>
			<TableCell>
				<Typography
					variant="body2"
					color="text.primary"
					onClick={() => handleClick(submission)}
					style={{ cursor: 'pointer' }}
				>
					{submission.status}
				</Typography>
			</TableCell>
			<TableCell>
				<Typography
					variant="body2"
					color="text.primary"
					onClick={() => handleClick(submission)}
					style={{ cursor: 'pointer' }}
				>
					{submission.user.full_name}
				</Typography>
			</TableCell>
			<TableCell>
				<Typography
					variant="body2"
					color="text.primary"
					onClick={() => handleClick(submission)}
					style={{ cursor: 'pointer' }}
				>
					{submission.submitted_at}
				</Typography>
			</TableCell>
		</TableRow>
	);
}
